module.exports = __webpack_public_path__ + "static/sohan-382857a16140ea927e944d64655e2744.jpeg";